<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h2>
                {{ 'main.nav.links.parameters.providerFiles.shortLabel' | translate }}
                <app-tooltip [text]="'main.nav.links.parameters.providerFiles.summary' | translate"></app-tooltip>
            </h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <mat-progress-bar *ngIf="isLoading" class="progress-bar" mode="indeterminate" color="accent"></mat-progress-bar>
        <mat-tab-group color="accent" class="years-tabs" animationDuration="0ms">
            <mat-tab *ngFor="let year of years" [label]="year.year">
                <section class="tab-content">
                    <app-config-files-list [files]="year.files"
                        [selectedFileId]="year.selectedFileId"
                        (selectedFileChanged)="onSelectFile($event, year.year)"></app-config-files-list>
                </section>
            </mat-tab>
        </mat-tab-group>
    </mat-card-content>
    <mat-card-actions>
        <a mat-raised-button color="accent" [routerLink]="backLink.route">
            <mat-icon aria-label="Back">{{ backLink.icon }}</mat-icon>
            {{ backLink.title | translate }}
        </a>
    </mat-card-actions>
</mat-card>
